import React from 'react';
import kjedeCardsCSS from './kjedeCards.module.css';
import CustomButton from '../../customButton';
// import Image from 'react-bootstrap/Image';
//import FormModal from '../../formModal';
import VPLogo from '../../../images/Logo.png';



export function VpAdminKjedeCard({ kjede }) {

    const { name, frakt_inkludert, discount } = kjede.attributes;
    
    let imageSrc = kjede.attributes?.image?.data?.attributes?.url || VPLogo;

    return(
            <div className={kjedeCardsCSS.card}>
                <div
                    className={kjedeCardsCSS.bgImage}
                    style={{
                        backgroundImage: `url(${imageSrc})`,
                    }}
                    aria-label={name}  // Bruk aria-label for tilgjengelighet, eller bruk title
                    >
                </div>
                <div className="">
                    <div className={kjedeCardsCSS.produktNavn}>
                        {name}
                    </div>
                    <div>
                        {discount}
                    </div>
                    <div>
                        {frakt_inkludert}
                    </div>
                    {/* <div className="mt-auto">
                        {varenummer}
                    </div> */}
                    <div className="text-center mt-auto">
                    {/* <Link to={`/admin/verksted/${verksted.id}`}> */}
                        <CustomButton 
                            label="Trykk for mer info"
                            className={kjedeCardsCSS.cardButton1}
                        />
                    {/* </Link> */}
                    </div>
                    {/* <div className="text-center mt-auto">
                        <FormModal 
                            buttonTitle="Rediger informasjon" 
                            modalTitle="Rediger produkt" 
                            body={<UpdateKjedeForm
                                kjede={kjede} />}
                            openButtonClass={kjedeCardsCSS.cardButton2} 
                            closeButtonClass={kjedeCardsCSS.closeButton}
                        />
                    </div> */}
                    <div className="text-center mt-auto">
                        <CustomButton 
                            label="Slett kjede"
                            className={kjedeCardsCSS.cardButton3}
                            // onClick={() => removeProduct(kjede.id)}
                        />
                    </div>
                </ div>
            </ div>
    )
}

export default VpAdminKjedeCard;